import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Replace with your actual Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAXWq_Z6Xov9HlLlJ07hbnqRaJ_huREO7Q",
    authDomain: "sigile-app.firebaseapp.com",
    projectId: "sigile-app",
    storageBucket: "sigile-app.firebasestorage.app",
    messagingSenderId: "25413137948",
    appId: "1:25413137948:web:5030c2a7c94abdd101d1d9",
    measurementId: "G-9TXJX3MYNJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
